import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "account" */ './index'),
  loading: () => null,
})
